(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cdi-pdp-addons-block"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  function initAddons(container) {
    var errorEl = container.querySelector('[id^="cdi-pdp-addons-error-"]');
    var addonsSubmitting = false;

    function getCheckedVariantIds() {
      return Array.from(container.querySelectorAll('[data-addon-select]:checked'))
        .map(function (el) { return parseInt(el.value, 10); })
        .filter(Boolean);
    }

    function uncheckAll() {
      container.querySelectorAll('[data-addon-select]:checked').forEach(function (el) {
        el.checked = false;
      });
      if (window.cdiAddonSync) window.cdiAddonSync();
    }

    function showError() {
      if (errorEl) errorEl.removeAttribute('hidden');
    }

    function hideError() {
      if (errorEl) errorEl.setAttribute('hidden', '');
    }

    function getCartElement() {
      return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    }

    function getSectionsParam(cartEl) {
      if (!cartEl || typeof cartEl.getSectionsToRender !== 'function') return '';
      return cartEl.getSectionsToRender()
        .map(function (s) { return s.section || s.id; })
        .filter(Boolean)
        .join(',');
    }

    function filterAlreadyInCart(variantIds, cartItems) {
      if (!cartItems || !cartItems.length) return variantIds;
      var existingVariantIds = cartItems.map(function (item) { return item.variant_id; });
      return variantIds.filter(function (id) { return existingVariantIds.indexOf(id) === -1; });
    }

    function addAddonsToCart(variantIds) {
      if (!variantIds.length) return Promise.resolve(null);

      var cartEl = getCartElement();
      var sectionsParam = getSectionsParam(cartEl);

      var body = { items: variantIds.map(function (id) { return { id: id, quantity: 1 }; }) };
      if (sectionsParam) body.sections = sectionsParam;

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) {
              console.error('[CDI Add-ons] /cart/add.js error', res.status, data);
              throw new Error('cart/add failed: ' + res.status);
            }
            return { cartEl: cartEl, data: data };
          });
        });
    }

    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || event.source !== 'product-form') return;
      if (addonsSubmitting) return;

      var ids = getCheckedVariantIds();
      if (!ids.length) return;

      var cartItems = (event.cartData && event.cartData.items) ? event.cartData.items : [];
      var newIds = filterAlreadyInCart(ids, cartItems);
      if (!newIds.length) return;

      addonsSubmitting = true;
      hideError();

      return addAddonsToCart(newIds)
        .then(function (result) {
          if (!result) return;

          uncheckAll();

          var cartEl = result.cartEl;
          var data = result.data;

          if (cartEl && data.sections && typeof cartEl.renderContents === 'function') {
            cartEl.renderContents(data);
          }
        })
        .catch(function (err) {
          console.error('[CDI Add-ons] cart add failed', err);
          showError();
        })
        .finally(function () {
          addonsSubmitting = false;
        });
    });
  }

  document.querySelectorAll('[data-cdi-addons]').forEach(initAddons);

  document.querySelectorAll('[data-addons-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var gridId = btn.getAttribute('data-grid-id');
      var grid = gridId ? document.getElementById(gridId) : null;
      if (!grid) return;

      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      grid.toggleAttribute('data-expanded');

      var labelEl = btn.querySelector('.cdi-pdp-addons__toggle-label');
      if (labelEl) {
        labelEl.textContent = expanded
          ? btn.getAttribute('data-show-more')
          : btn.getAttribute('data-show-less');
      }
    });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cdi-pdp-key-features"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('[data-cdi-key-features]').forEach(function (root) {
      var btn = root.querySelector('[data-kf-expand]');
      if (!btn) return;
      var label = btn.querySelector('[data-kf-label]');
      var labelMore = btn.getAttribute('data-label-more');
      var labelLess = btn.getAttribute('data-label-less');

      btn.addEventListener('click', function () {
        var isExpanded = root.classList.contains('cdi-pdp__key-features--expanded');
        if (isExpanded) {
          root.classList.remove('cdi-pdp__key-features--expanded');
          root.classList.add('cdi-pdp__key-features--clamped');
          btn.setAttribute('aria-expanded', 'false');
          if (label) label.textContent = labelMore;
        } else {
          root.classList.remove('cdi-pdp__key-features--clamped');
          root.classList.add('cdi-pdp__key-features--expanded');
          btn.setAttribute('aria-expanded', 'true');
          if (label) label.textContent = labelLess;
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cdi-pdp-vehicle-details"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  function buildDropdown(cdiSelect) {
    var nativeSelect = cdiSelect.querySelector('select');
    var trigger      = cdiSelect.querySelector('.cdi-select__trigger');
    var valueEl      = cdiSelect.querySelector('.cdi-select__value');
    var dropdown     = cdiSelect.querySelector('.cdi-select__dropdown');

    if (!nativeSelect || !trigger || !valueEl || !dropdown) return;

    function renderOptions() {
      dropdown.innerHTML = '';
      Array.prototype.forEach.call(nativeSelect.options, function (opt) {
        if (!opt.value) return;
        var li = document.createElement('li');
        li.className = 'cdi-select__option';
        if (opt.disabled || opt.hidden) li.classList.add('cdi-select__option--disabled');
        if (opt.value === nativeSelect.value) li.classList.add('cdi-select__option--selected');
        li.setAttribute('role', 'option');
        li.setAttribute('aria-selected', String(opt.value === nativeSelect.value));
        li.dataset.value = opt.value;
        li.textContent = opt.text;
        dropdown.appendChild(li);
      });
    }

    function selectValue(value, label, isPlaceholder) {
      nativeSelect.value = value;
      valueEl.textContent = label;
      if (isPlaceholder) {
        valueEl.classList.add('cdi-select__value--placeholder');
      } else {
        valueEl.classList.remove('cdi-select__value--placeholder');
      }
      var event = new Event('change', { bubbles: true });
      nativeSelect.dispatchEvent(event);
    }

    function open() {
      renderOptions();
      dropdown.removeAttribute('hidden');
      cdiSelect.setAttribute('aria-expanded', 'true');
      cdiSelect.classList.add('cdi-select--open');
      var selected = dropdown.querySelector('.cdi-select__option--selected');
      if (selected) selected.scrollIntoView({ block: 'nearest' });
    }

    function close() {
      cdiSelect.setAttribute('aria-expanded', 'false');
      cdiSelect.classList.remove('cdi-select--open');
      setTimeout(function () {
        if (!cdiSelect.classList.contains('cdi-select--open')) {
          dropdown.setAttribute('hidden', '');
        }
      }, 150);
    }

    function toggle() {
      if (cdiSelect.classList.contains('cdi-select--open')) {
        close();
      } else {
        document.querySelectorAll('.cdi-select--open').forEach(function (el) {
          if (el !== cdiSelect) el.querySelector('.cdi-select__trigger') && el.dispatchEvent(new CustomEvent('cdi:select:close'));
        });
        open();
      }
    }

    function getFocusedOption() {
      return dropdown.querySelector('.cdi-select__option--focused');
    }

    function moveFocus(delta) {
      var options = Array.prototype.filter.call(
        dropdown.querySelectorAll('.cdi-select__option'),
        function (li) { return !li.classList.contains('cdi-select__option--disabled'); }
      );
      if (!options.length) return;
      var current = getFocusedOption();
      var idx = current ? options.indexOf(current) : -1;
      if (current) current.classList.remove('cdi-select__option--focused');
      var next = options[Math.max(0, Math.min(options.length - 1, idx + delta))];
      if (next) {
        next.classList.add('cdi-select__option--focused');
        next.scrollIntoView({ block: 'nearest' });
      }
    }

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      toggle();
    });

    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        if (!cdiSelect.classList.contains('cdi-select--open')) {
          open();
          moveFocus(0);
        } else if (e.key === 'ArrowDown') {
          moveFocus(1);
        } else if (e.key === 'ArrowUp') {
          moveFocus(-1);
        }
      }
      if (e.key === 'Escape') {
        close();
        trigger.focus();
      }
    });

    dropdown.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); moveFocus(1); }
      if (e.key === 'ArrowUp')   { e.preventDefault(); moveFocus(-1); }
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        var focused = getFocusedOption();
        if (focused) focused.click();
      }
      if (e.key === 'Escape') { close(); trigger.focus(); }
      if (e.key === 'Tab') { close(); }
    });

    dropdown.addEventListener('click', function (e) {
      var option = e.target.closest('.cdi-select__option');
      if (!option || option.classList.contains('cdi-select__option--disabled')) return;
      var isPlaceholder = option.classList.contains('cdi-select__option--placeholder');
      selectValue(option.dataset.value, option.textContent, isPlaceholder);
      renderOptions();
      close();
      trigger.focus();
    });

    document.addEventListener('click', function (e) {
      if (!cdiSelect.contains(e.target)) close();
    }, { passive: true });

    cdiSelect.addEventListener('cdi:select:close', close);

    if (nativeSelect.value) {
      var selectedOpt = nativeSelect.options[nativeSelect.selectedIndex];
      if (selectedOpt) selectValue(selectedOpt.value, selectedOpt.text, false);
    }
  }

  var vehicleForm = document.querySelector('[data-cdi-vehicle-form]');
  if (!vehicleForm) return;

  var sectionWrapper = vehicleForm.closest('.shopify-section');
  if (!sectionWrapper) return;

  var rawId = sectionWrapper.id.replace('shopify-section-', '');
  var productForm = document.getElementById('product-form-' + rawId);
  if (!productForm) return;

  var CAB_MAP = {
    'Toyota Hilux':           ['Dual Cab', 'Extra Cab', 'Single Cab'],
    'Ford Ranger':            ['Dual Cab', 'Extra Cab', 'Single Cab'],
    'VW Amarok':              ['Dual Cab', 'Single Cab'],
    'Toyota LC79':            ['Dual Cab', 'Single Cab'],
    'Jeep Gladiator':         ['Dual Cab'],
    'LDV T60':                ['Dual Cab'],
    'GWM Cannon':             ['Dual Cab'],
    'GWM Cannon Alpha':       ['Dual Cab'],
    'Mazda BT-50':            ['Dual Cab', 'Extra Cab', 'Single Cab'],
    'ISUZU D-MAX':            ['Dual Cab', 'Extra Cab', 'Single Cab'],
    'Holden Colorado':        ['Dual Cab', 'Extra Cab', 'Single Cab'],
    'Nissan Navara':          ['Dual Cab', 'Extra Cab', 'Single Cab'],
    'Mitsubishi Triton':      ['Dual Cab', 'Extra Cab', 'Single Cab'],
    'SsangYong Musso':        ['Dual Cab'],
    'KIA Tasman':             ['Dual Cab', 'Single Cab'],
    'BYD Shark 6':            ['Dual Cab'],
    'Other (Please specify)': ['Dual Cab', 'Extra Cab', 'Single Cab']
  };

  var modelNativeSelect = vehicleForm.querySelector('[name="properties[Vehicle Model]"]');
  var cabNativeSelect   = vehicleForm.querySelector('[data-vehicle-cab-select]');
  var cabCdiSelect      = cabNativeSelect ? cabNativeSelect.closest('[data-cdi-select]') : null;

  function filterCabOptions(modelValue) {
    if (!cabNativeSelect) return;
    var allowed = CAB_MAP[modelValue];
    if (cabNativeSelect.value && allowed && allowed.indexOf(cabNativeSelect.value) === -1) {
      cabNativeSelect.value = '';
      if (cabCdiSelect) {
        var cabTriggerValue = cabCdiSelect.querySelector('.cdi-select__value');
        var cabTrigger      = cabCdiSelect.querySelector('.cdi-select__trigger');
        if (cabTriggerValue) {
          cabTriggerValue.textContent = cabTrigger && cabTrigger.dataset.placeholder
            ? cabTrigger.dataset.placeholder
            : 'eg: Dual Cab';
          cabTriggerValue.classList.add('cdi-select__value--placeholder');
        }
        var resetEvent = new Event('change', { bubbles: true });
        cabNativeSelect.dispatchEvent(resetEvent);
      }
    }
    Array.prototype.forEach.call(cabNativeSelect.options, function (opt) {
      if (!opt.value) return;
      var permitted = !allowed || allowed.indexOf(opt.value) !== -1;
      opt.disabled = !permitted;
      opt.hidden   = !permitted;
    });
    if (cabCdiSelect && cabCdiSelect.classList.contains('cdi-select--open')) {
      var dropdown = cabCdiSelect.querySelector('.cdi-select__dropdown');
      if (dropdown) {
        var tempFn = cabCdiSelect._renderOptions;
        if (typeof tempFn === 'function') tempFn();
      }
    }
  }

  if (modelNativeSelect) {
    modelNativeSelect.addEventListener('change', function () {
      filterCabOptions(this.value);
    });
    if (modelNativeSelect.value) filterCabOptions(modelNativeSelect.value);
  }

  vehicleForm.querySelectorAll('[data-cdi-select]').forEach(buildDropdown);

  productForm.addEventListener('submit', function () {
    vehicleForm.querySelectorAll('[data-vehicle-input]').forEach(function (el) {
      var isEmpty = el.tagName === 'SELECT' ? !el.value : !el.value.trim();
      if (isEmpty) el.disabled = true;
    });
  });

  subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
    if (!event || event.source !== 'product-form') return;
    vehicleForm.querySelectorAll('[data-vehicle-input]').forEach(function (el) {
      el.disabled = false;
    });
  });

  productForm.addEventListener('reset', function () {
    vehicleForm.querySelectorAll('[data-vehicle-input]').forEach(function (el) {
      el.disabled = false;
    });
    vehicleForm.querySelectorAll('[data-cdi-select]').forEach(function (cdiSelect) {
      var nativeSelect = cdiSelect.querySelector('select');
      var valueEl      = cdiSelect.querySelector('.cdi-select__value');
      var triggerBtn   = cdiSelect.querySelector('.cdi-select__trigger');
      if (nativeSelect && valueEl) {
        nativeSelect.value = '';
        valueEl.textContent = triggerBtn && triggerBtn.dataset.placeholder
          ? triggerBtn.dataset.placeholder
          : '';
        valueEl.classList.add('cdi-select__value--placeholder');
      }
    });
    if (cabNativeSelect) {
      Array.prototype.forEach.call(cabNativeSelect.options, function (opt) {
        opt.disabled = false;
        opt.hidden   = false;
      });
    }
  });

})();
  } catch(e) { console.error(e); }
})();

})();
